export const UPDATE_AUTH_STATE = 'AUTH_UPDATE_AUTH_STATE'
export const UPDATE_GENERAL_DID_ERROR = 'UPDATE_GENERAL_DID_ERROR'
